import { useAuthBearerFetch } from "matsuri-hooks"
import { m2mCleaning_cleanerV3 } from "@/endpoints/m2m-cleaning.cleaner-v3"

export type CheckinOnDateByOperationIdsOutput = Record<
    string, // operationId
    { hasCheckinOnDate: boolean } | undefined
>

export const useCheckinOnDateByOperationIds = (
    token: string,
    operationIds: string[]
) => {
    const endpoint = m2mCleaning_cleanerV3.checkCleaningsCheckinByIds
    return useAuthBearerFetch<CheckinOnDateByOperationIdsOutput>(
        token,
        operationIds.length > 0 ? endpoint() : null,
        {
            method: endpoint.method,
            body: JSON.stringify({ cleaningIds: operationIds })
        }
    )
}
